import React from 'react';

import { Switch, HashRouter } from 'react-router-dom';

import Route from './Route';

import Produtos from '~/pages/Produtos';
import Clientes from '~/pages/Clientes';

import Pedidos from '~/pages/Pedidos';
import Pedido from '~/pages/Pedido';

import Dashboard from '~/pages/Dashboard';

import VendasMensais from '~/pages/VendasMensais';
import VendasDiarias from '~/pages/VendasDiarias';
import VendasPorHorario from '~/pages/VendasPorHorario';
import VendasPorEstado from '~/pages/VendasPorEstado';
import VendasPorCanal from '~/pages/VendasPorCanal';
import TopProdutos from '~/pages/TopProdutos';
import VendasPorCategoria from '~/pages/VendasPorCategoria';
import VendasAnuais from '~/pages/VendasAnuais';

import Painel from '~/pages/Painel';
import CurvaABC from '~/pages/CurvaABC';
import EstoquePreditivo from '~/pages/EstoquePreditivo';
import GestaoDeGiro from '~/pages/GestaoDeGiro';
import SugestaoDeCompras from '~/pages/SugestaoDeCompras';
import Ranking from '~/pages/Ranking';

import Avisos from '~/pages/Avisos';

const Routes: React.FC = () => (
  <HashRouter>
    <Switch>
      <Route path="/" exact component={Dashboard} isPrivate />
      <Route path="/inicio" exact component={Dashboard} isPrivate />
      <Route path="/dashboard" component={Dashboard} isPrivate />
      <Route path="/produtos" component={Produtos} isPrivate />
      <Route path="/clientes" component={Clientes} isPrivate />
      <Route path="/pedidos" component={Pedidos} isPrivate />
      <Route path="/Pedido/:id" component={Pedido} isPrivate />
      <Route path="/avisos" component={Avisos} isPrivate />

      <Route path="/vendas-anuais" component={VendasAnuais} isPrivate />
      <Route path="/vendas-mensais" component={VendasMensais} isPrivate />

      <Route path="/vendas-diarias" component={VendasDiarias} isPrivate />

      <Route
        path="/vendas-por-horario"
        component={VendasPorHorario}
        isPrivate
      />

      <Route path="/vendas-por-estado" component={VendasPorEstado} isPrivate />
      <Route path="/vendas-por-canal" component={VendasPorCanal} isPrivate />
      <Route path="/top-produtos" component={TopProdutos} isPrivate />

      <Route
        path="/vendas-por-categoria"
        component={VendasPorCategoria}
        isPrivate
      />

      <Route path="/painel" component={Painel} isPrivate />
      <Route path="/curva-abc" component={CurvaABC} isPrivate />
      <Route path="/estoque-preditivo" component={EstoquePreditivo} isPrivate />
      <Route path="/gestao-de-giro" component={GestaoDeGiro} isPrivate />

      <Route path="/sugestao-de-compras" component={SugestaoDeCompras} isPrivate />

      <Route path="/ranking" component={Ranking} isPrivate />

    </Switch>
  </HashRouter>
);

export default Routes;
